import { PlusOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Flex,
  Form,
  Input,
  Layout,
  Modal,
  Row,
  Select,
  Table,
  TableProps
} from "antd";
import { ColumnsType } from "antd/es/table";
import { get, isEmpty, toNumber } from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionContent from "src/components/common/ActionContent";
import FilterAction from "src/components/common/FilterAction";
import ModalDeleteConfirm from "src/components/common/ModalDeleteConfirm";
import { apiCaller, cancelListToken } from "src/util/apiCaller";
import {
  getLocalStorage,
  reDataForTable,
  setLocalStorage
} from "src/util/Commom";
import { MessageStatusError } from "src/util/MessageStatus";

const FormItem = Form.Item;

const LoaiTaiLieu = ({ status }: any) => {
  const [form] = Form.useForm();

  const { isActive } = status;
  const [isLoadTable, setIsLoadTable] = useState<boolean>(false);
  const [datatable, setDatatable] = useState([]);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyword] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [idNhomTuLieu, setIdNhomTuLieu] = useState(undefined);
  const [listNhomTaiLieu, setListNhomTaiLieu] = useState([]);
  const [isLoadLoaiBaoCao, setIsLoadLoaiBaoCao] = useState(false);
  const [isSearchClick, setIsSearchClick] = useState(false);
  const pageSize = 10;
  const navigate = useNavigate();
  const { setFieldsValue } = form;

  useEffect(() => {
    if (isActive) {
      const state = getLocalStorage("dataFilter") || undefined;
      if (state) {
        setKeyword(state.keyword);
        setIdNhomTuLieu(state.idNhomTuLieu);
        setActivePage(state.activePage);
        getListData(state.activePage, state.idNhomTuLieu, state.keyword);
        setFieldsValue({
          loaitulieu: {
            idNhomTuLieu: state.idNhomTuLieu,
            keyword: state.keyword
          }
        });
      } else {
        getListData(activePage, idNhomTuLieu, keyword);
      }
      getLoaiBaoCao();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["listloaitulieus", "listNhomTaiLieu"]);
    };
  }, []);

  /**
   * getListData: danh sách nhóm báo cáo
   * @param {number} activePage
   * @param {number} idNhomTuLieu
   * @param {string} keyword
   * @memberof QuanLyLoaiBaoCao
   */
  const getListData = async (
    activePage: number,
    idNhomTuLieu: any,
    keyword: string
  ) => {
    setIsLoadTable(true);
    const configAPI = {
      url: `api/loaitulieus?page=${activePage}&size=${pageSize}&idnhomtulieu=${
        idNhomTuLieu || ""
      }&keyword=${keyword}&properties_sort=id&type_soft=asc`,
      method: "GET",
      value: null,
      apiType: "LIST",
      getName: "listloaitulieus"
    } as any;
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = reDataForTable(
          get(response.data, "content", []),
          activePage,
          pageSize
        );
        setDatatable(data as any);
        setTotal(get(response.data, "totalElements", 0));
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } finally {
      setIsLoadTable(false);
    }
  };

  /**
   * getLoaiBaoCao: Gọi api list loại tài liệu
   * @memberof LoaiTaiLieu
   */
  const getLoaiBaoCao = async () => {
    setIsLoadLoaiBaoCao(true);
    const configAPI = {
      url: `api/nhomtulieus?keyword`,
      method: "GET",
      value: null,
      apiType: "LIST",
      params: {
        page: -1
      },
      getName: "listNhomTaiLieu"
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        const data = get(response.data, "content", []);
        setListNhomTaiLieu(data);
        setIsLoadLoaiBaoCao(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadLoaiBaoCao(false);
      }
    } catch (error) {
      setIsLoadLoaiBaoCao(false);
      error;
    }
  };

  const columns: ColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "key",
      key: "key",
      width: "5%",
      align: "center",
      render: (e) => <span>{e}</span>
    },
    {
      title: "Tên loại tài liệu",
      dataIndex: "tenLoaiTuLieu",
      key: "tenLoaiTuLieu",
      render: (text, record) => renderTitle(text, record)
    },
    {
      title: "Tên nhóm tài liệu",
      dataIndex: "idNhomTuLieu",
      key: "idNhomTuLieu",
      width: "25%",
      render: (item) => renderNhomTuLieu(item)
    },
    {
      title: "Hành động",
      dataIndex: "",
      key: "x",
      align: "center",
      width: "10%",
      render: (item) => actionContent(item)
    }
  ];

  /**
   * renderTitle: hiển thị màu title table
   * @param {String} text
   * @param {object} record
   * @param {String} title
   * @memberof LoaiTaiLieu
   */
  const renderTitle = (text: any, record: any) => (
    <span
      onClick={() => onClickInfo(record)}
      style={{ cursor: "pointer", color: "#0065ff" }}
      title="Xem chi tiết"
    >
      {text}
    </span>
  );

  const onClickInfo = (record: any) => {
    const itemNhomTuLieu = listNhomTaiLieu.find(
      (value: any) => value.id === record.idNhomTuLieu
    );
    const tenNhomTuLieu = get(itemNhomTuLieu, "tenNhomTuLieu", "");
    Modal.info({
      title: "Chi tiết loại tài liệu",
      content: (
        <div>
          <p>
            <b>Tên loại tài liệu:</b> {record.tenLoaiTuLieu}
          </p>
          <p>
            <b>Tên nhóm tài liệu:</b> {tenNhomTuLieu}
          </p>
        </div>
      ),
      okText: "Đóng",
      onOk() {}
    });
  };

  /**
   * renderNhomTuLieu: Cho phép nhấp vào text để xem chi tiết
   * @param {String} text
   * @param {object} record
   * @memberof loaitulieu
   */
  const renderNhomTuLieu = (item: number) => {
    const itemNhomTuLieu = listNhomTaiLieu.find(
      (value: any) => value.id === item
    );
    const tenNhomTuLieu = get(itemNhomTuLieu, "tenNhomTuLieu", "");
    return <span>{tenNhomTuLieu}</span>;
  };

  /**
   * actionContent: Hành động trên bảng
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const actionContent = (item: object) => {
    return (
      <ActionContent
        onDeleteItem={() => deleteItemFunc(item)}
        onEditItem={() => handleRedirect("edit", item)}
      />
    );
  };

  /**
   * deleteItemFunc: Xoá item theo item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemFunc = (item: object) => {
    ModalDeleteConfirm(deleteItemAction, item);
  };

  /**
   * deleteItemAction: Xóa item
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const deleteItemAction = async (item: any) => {
    setIsLoadTable(true);
    const config = {
      url: `api/loaitulieu/${item.id}`,
      apiType: "DELETE",
      value: null,
      method: "DELETE",
      getName: "deleteLoaiTaiLieu"
    };
    const response = await apiCaller(config);
    try {
      if (response?.status === 200 || response?.status === 201) {
        const dataPage = total - (activePage - 1) * pageSize;
        const page = dataPage <= 1 && total !== 1 ? activePage - 1 : activePage;
        getListData(page, idNhomTuLieu, keyword);
        setIsLoadTable(false);
      } else {
        MessageStatusError(toNumber(response?.status));
        setIsLoadTable(false);
      }
    } catch (error) {
      setIsLoadTable(false);
    }
  };

  /**
   * handleRedirect: Chuyển trang thêm mới và chỉnh sửa
   * @param {string} type
   * @param {object} item
   * @memberof LoaiTaiLieu
   */
  const handleRedirect = (type = "", item: any) => {
    let pathname = "/quan-tri/loai-tu-lieu";
    switch (type) {
      case "new":
        pathname += "/them-moi/";
        break;
      case "edit":
        pathname += `/${item.id}/chinh-sua/`;
        break;
      case "view":
        pathname += `/${item.id}/chi-tiet/`;
        break;
      default:
        break;
    }
    navigate(pathname, { state: { itemData: item } });
    if (isSearchClick) {
      const content = {
        keyword,
        idNhomTuLieu,
        activePage,
        pageSize,
        pathname: "quan-tri/loai-tu-lieu"
      };
      setLocalStorage("dataFilter", content);
    }
  };

  /**
   * handleTableChange: Fetch dữ liệu dựa theo thay đổi trang
   * @param {object} pagination
   * @memberof LoaiTaiLieu
   */
  const handleTableChange: TableProps["onChange"] = (pagination) => {
    const activePage = pagination.current as number;
    getListData(activePage, idNhomTuLieu, keyword);
    setActivePage(activePage);
  };

  /**
   * onChangeText: Thay đổi keyword tìm kiếm
   * @param {object} e
   * @memberof LoaiTaiLieu
   */
  const onChangeText = (e: any) => {
    const keyword = e.target.value;
    setKeyword(keyword);
  };

  /**
   * onChangeNhomTuLieu: chọn nhóm tài liệu
   * @param {object} e
   * @memberof LoaiTaiLieu
   */
  const onChangeNhomTuLieu = (e: any) => {
    setIdNhomTuLieu(e);
  };

  /**
   * handleSubmit: Thực hiện hành động tìm kiếm
   * @memberof LoaiTaiLieu
   */
  const handleSubmit = () => {
    setIsSearchClick(true);
    getListData(activePage, idNhomTuLieu, keyword);
  };

  /**
   * handleReset: làm mới form tìm kiếm
   * @memberof LoaiTaiLieu
   */
  const handleReset = () => {
    setKeyword("");
    setFieldsValue({
      loaitulieu: {
        idNhomTuLieu: undefined,
        keyword: ""
      }
    });
    setIdNhomTuLieu(undefined);
  };

  return (
    <Layout>
      <Flex justify="space-between" align="center">
        <h3 style={{ color: "black", fontSize: 20 }}>Quản lý loại tài liệu</h3>
        <Button
          className="heading-button-addnew btn"
          type="primary"
          onClick={() => handleRedirect("new", null)}
          icon={<PlusOutlined />}
        >
          Thêm mới
        </Button>
      </Flex>
      <Card>
        <Form layout="vertical" form={form} name="quyen-control">
          <Col>
            <Row gutter={16} style={{ marginTop: -2 }}>
              <Col md={8} xs={24}>
                <FormItem
                  className="QTI-FormItemSelect"
                  label="Nhóm tài liệu"
                  name={["loaitulieu", "idNhomTuLieu"]}
                  initialValue={idNhomTuLieu || undefined}
                >
                  <Select
                    allowClear
                    onChange={onChangeNhomTuLieu}
                    loading={isLoadLoaiBaoCao}
                    placeholder="Chọn nhóm tài liệu"
                    style={{ width: "100%" }}
                    options={listNhomTaiLieu}
                    fieldNames={{ label: "tenNhomTuLieu", value: "id" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem
                  className="ant-input-group"
                  label="Nhập từ khóa"
                  name={["loaitulieu", "keyword"]}
                >
                  <Input
                    placeholder="Nhập từ khóa..."
                    onChange={onChangeText}
                    onPressEnter={handleSubmit}
                    style={{ width: "100%" }}
                  />
                </FormItem>
              </Col>
              <Col md={8} xs={24}>
                <FormItem label={<span>&nbsp;</span>}>
                  <FilterAction search={handleSubmit} reset={handleReset} />
                </FormItem>
              </Col>
            </Row>
          </Col>
        </Form>
        <Table
          rowKey={"id"}
          bordered
          columns={columns}
          className="qti-table-wrapper gx-table-responsive"
          dataSource={datatable}
          rowClassName={(record, index) =>
            index % 2 === 0 ? "qti-table-row-background" : ""
          }
          size="middle"
          pagination={{
            current: activePage,
            pageSize,
            total,
            showSizeChanger: false,
            showQuickJumper: false,
            showTotal: (total) =>
              pageSize <= total
                ? `Hiển thị ${pageSize} trong tổng ${total}`
                : `Tổng ${total}`
          }}
          loading={isLoadTable}
          onChange={handleTableChange}
        />
      </Card>
    </Layout>
  );
};
export default LoaiTaiLieu;
